const INITIAL_STATE = {
  status: "PENDING",
  credit_cards: [],
  active_card_id: null,
  show_new_payment_method: false,
  new_payment_method_status: "READY"
}

export default INITIAL_STATE
